import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { FormField, Input } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { AppContext } from '@src/context/store';
import { getAppSettings, getTranslations } from '@src/context/selectors/ui-settings';
import { TranslationKey } from '@src/types';

export const SaveButtonText = translate()(({ t }: InjectedTranslateProps) => {
  const store = React.useContext(AppContext);
  const translations = getTranslations(store);
  const saveButtonText = translations[TranslationKey.SaveButton];

  const onChange = (value: string) => store.updatePendingTranslations({ [TranslationKey.SaveButton]: value });

  return (
    <FormField
      label={t('advanced-options.categories.display.save.title')}
      infoContent={t('advanced-options.categories.display.save.tooltip')}
      charCount={20 - saveButtonText.length}
    >
      <Input
        dataHook={DataHooks.AdvancedCategoriesSave}
        maxLength={20}
        value={saveButtonText}
        onChange={(event) => onChange(event.target.value)}
      />
    </FormField>
  );
});
